import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface ScreenOverlayStyles {
  container: Styles
}

export const useStyles = createUseStyles<ScreenOverlayStyles>((theme) => {
  return {
    container: {
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: 999999,
      width: '100vw',
      height: '100vh',
      opacity: 0.5,
      userSelect: 'none',
      background: theme.colors.webFadedBackground,
    },
  }
})
